<template>
  <div class="launchpack-delivery">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    >
      <div slot="partner" v-if="$store.getters.mode!=='partner'">
        <lp-adm-drop-input :data.sync="partners"
                           @onSelect="selectPartner"
                           placeholder="검색 후 선택"
                           listAlign="left"
                           width="250px"
                           style="margin-top:12px;"></lp-adm-drop-input>
      </div>
    </admin-filter>

    <div class="btn-group-justify-end">
      <button class="button" style="width:150px" @click="orderDownloadFile('?start_status=500&end_status=501')">
        <img style="width: 10px;margin-right: 4px;"
             src="~assets/image/excel_icon.png"/>
        <span>주문 내역 다운로드</span></button>
    </div>

    <order-table
      ref="orderTable"
      :field_list="tableData"
      :items="tableItems"
      :filtered="filtered"
      :allCount="allCount"
      :filteredCount="filteredCount"
      @check="clickCheckBox"
      :table_width="1800"
      @getData="getDataFromServer"
      @ordering="ordering"
      @selPageLength="selPageLength">
      <td slot="checkspot" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!--   수령 희망일   -->
      <td slot="order__hope_day" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.hope_day }}</td>

<!--  결제일   -->
<!--  결제일   -->
      <td slot="order__pay_day" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <div v-if="props.item.order.pay_type===900">결제 없음</div>
        <div v-else-if="props.item.order.pay_type===901">결제 대기</div>
        <div v-else>{{ props.item.order.pay_day }}</div>
      </td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(`${props.item.order.id}&page=OrderListCancelNew`)" class="unselect" style="text-decoration:underline">{{ props.item.id }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.name }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div class="flex align-center unselect"
             @click="routerProduct(props.item.product)">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px" v-if="props.item.product.img">
          <div style="text-align: left">
            <div v-if="props.item.order_product_option.length>0">
              <div>{{ props.item.product.name }}</div>
              <div
                v-for="(option, option_idx) in props.item.order_product_option"
                :key="'option-'+option_idx">
                <span v-if="option.option.option_type===0">기본옵션:</span>
                <span v-if="option.option.option_type===1">추가옵션:</span>
                {{ optionFullName(option) }}
              </div>
            </div>
            <div v-else>
              {{ props.item.product.name }}
            </div>
          </div>
        </div>
      </td>

      <!-- 수량 -->
      <td slot="quantity" slot-scope="props">{{ props.item.quantity }}</td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배달 금액 -->
      <td slot="delivery_cost" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.delivery_cost | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.total_price | currency }}</td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <div v-if="props.item.partner">{{ props.item.partner }}</div>
        <div v-else>-</div>
      </td>

      <!-- 취소사유 -->
      <td slot="reason" slot-scope="props">{{ props.item.reason }}</td>

      <!-- 상태 -->
      <td slot="status_kor" slot-scope="props">{{ props.item.status_kor }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type_kor }}</span></td>

      <!-- 상태 변경 -->
      <td slot="status_change" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <button class="button" @click="openRefund(props.item)">환불 처리</button>
      </td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리</button>
        </div>
      </div>
    </order-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <!-- 환불 모달 -->
    <modal name="refundModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <order-refund class="lp-modal-wrapper"
                    :order="selectedOrder"
                    :order_product_list="order_product"
                    @confirm="successRefund"
                    @close="$modal.hide('refundModal')"></order-refund>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import MartMixin from "@/mixins/MartMixin"
  import OrderRefund from "../components/OrderRefund";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    name: 'OrderListCancelNew',
    components: {LpAdmDropInput, OrderRefund, LpCheckBool},
    mixins: [
      MartMixin
    ],
    data() {
      return {
        selectedOrder: undefined,
        order_product: []
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // (테이블 필드, 사용할 api, 현재페이지)
        // this.selectedTab=0;
        this.initializing('cancel_new', 'mart/orderproduct?start_status=500&end_status=501', 'OrderListCancelNew');
      },
      getDataFromServer() {
        this.getData();
      },
      openRefund (item) {
        this.$axios.get(this.getUrl(`mart/order/${item.order.id}`)).then(res => {
          this.selectedOrder = res.data;
          this.order_product = res.data.order_product;
          this.$modal.show('refundModal');
        });
      },
      successRefund () {
        this.getData();
        this.$modal.hide('refundModal');
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb
</style>
